import { FC, useState } from 'react';
import RoundButton from 'components/ui/roundButton';
import { ThemeSwitcherPanel } from './components/ThemeSwitcherPanel';
import './themeSwitcher.scss';

export const ThemeSwitcher: FC = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <RoundButton
        id='theme-button'
        icon='palette'
        iconSize={21}
        size={30}
        status='none'
        customClass='theme-switcher-button'
        onClick={() => setOpen(true)}
      />
      <ThemeSwitcherPanel isOpen={isOpen} onClose={() => setOpen(false)} />
    </div>
  );
};
